import { Box, Typography, Button, Grid2, DialogTitle } from "@mui/material";
import React from "react";

export default function FormTemplate({
  children,
  title,
  handleSubmit,
  isValid,
  onClose,
  extraLeftAction,
  headerRightAction,
  disableSubmitWhenInvalid = true,
}) {
  return (
    <Box
      sx={{
        height: "100%",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        bgcolor: "#2C2B2D",
        color: "#FFFFFF",
      }}
      fullWidth={true}
    >
      <DialogTitle
        sx={{
          flexShrink: 0,
          bgcolor: "#1E1E1E",
          color: "#0DA3E2",
          fontFamily: "Assistant, sans-serif",
          fontWeight: 600,
          fontSize: "28px",
          lineHeight: 1,
          px: "28px",
          py: "16px",
          borderBottom: "1px solid rgba(173, 180, 189, 0.2)",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 2,
            minHeight: 44,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center" }}>{title}</Box>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            {headerRightAction || null}
          </Box>
        </Box>
      </DialogTitle>

      <Box
        sx={{
          flex: 1,
          overflowY: "auto",
          display: "flex",
          flexDirection: "column",
          minHeight: 0,
          color: "#FFFFFF",
          bgcolor: "#2C2B2D",
        }}
      >
        <Box justifyContent="left" display="flex">
          <Grid2
            container
            direction="row"
            justifyContent="left"
            spacing={0}
            sx={{ p: "30px 32px 12px 32px", maxWidth: "100%" }}
          >
            {children}
          </Grid2>
        </Box>
      </Box>

      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        sx={{
          flexShrink: 0,
          mt: "auto",
          pb: "24px",
          px: "32px",
          bgcolor: "#2C2B2D",
        }}
      >
        <Box>
          {extraLeftAction || null}
        </Box>
        <Grid2
          container
          justifyContent="flex-end"
          spacing={1}
          sx={{
            width: "fit-content",
          }}
        >
          <Grid2 item>
            <Button
              variant="outlined"
              onClick={onClose}
              sx={{
                width: "187px",
                height: "50px",
                minWidth: "187px",
                borderRadius: "7px",
                borderColor: "#0DA3E2",
                color: "#FFFFFF",
                px: "10px",
                py: "10px",
                gap: "10px",
                textTransform: "none",
                "&:hover": {
                  borderColor: "#0DA3E2",
                  bgcolor: "rgba(13, 163, 226, 0.08)",
                },
              }}
            >
              <Typography color="#FFFFFF" fontWeight={700} fontSize="20px" lineHeight={1}>
                Cancel
              </Typography>
            </Button>
          </Grid2>
          <Grid2 item>
            <Button
              onClick={handleSubmit}
              aria-label="submit"
              variant="contained"
              disabled={disableSubmitWhenInvalid ? !isValid : false}
              sx={{
                width: "187px",
                height: "50px",
                minWidth: "187px",
                borderRadius: "7px",
                px: "10px",
                py: "10px",
                gap: "10px",
                textTransform: "none",
                bgcolor: "#0DA3E2",
                "&:hover": {
                  bgcolor: "#0DA3E2",
                  opacity: 0.92,
                },
                "&.Mui-disabled": {
                  bgcolor: "rgba(13, 163, 226, 0.45)",
                  color: "#FFFFFF",
                },
              }}
            >
              <Typography color="#FFFFFF" fontWeight={700} fontSize="20px" lineHeight={1}>
                Submit
              </Typography>
            </Button>
          </Grid2>
        </Grid2>
      </Box>
    </Box>
  );
}